// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"194":"menuitems","231":"checkout","496":"landingpages","576":"mainpages"}[chunkId] || chunkId) + "." + {"194":"c7945a38","231":"d9a8d198","496":"b558832b","576":"2021cc95","639":"65bb1201"}[chunkId] + ".js";
};